(function() {
  var module;

  try {
    // Get current templates module
    module = angular.module('manager');
  } catch (error) {
    // Or create a new one
    module = angular.module('manager', []);
  }

  module.run(['$templateCache', function($templateCache) {
    return $templateCache.put('components/area/area.tpl.html', [
'<div class="area clearfix">',
'',
'  <div class="col-md-{{ area.maponly ? \'12\' : \'8\' }}">',
'    <div class="map">',
'      <div class="attributions">',
'        © <a href="http://openstreetmap.org" rel="noopener noreferrer" target="blank_">OpenStreetMap</a>',
'        contributors.',
'      </div>',
'      <div class="btn-group selection" ng-if="!area.maponly">',
'        <select ng-change="area.selectBy()" ng-model="area.group" class="btn btn-default btn-sm">',
'          <option value="" selected disabled class="glyphicon glyphicon-ok-circle" translate>',
'            area.selection',
'          </option>',
'          <option value="all" class="alternate">— {{ \'area.all\' | translate }} —</option>',
'          <option value="{{group}}" ng-repeat="group in area.groups">{{group}}</option>',
'          <option value="none" class="alternate">— {{ \'area.none\' | translate }} —</option>',
'        </select>',
'        <button class="btn btn-default btn-sm ol-bbox" title="{{ \'area.selectByBBOX\' | translate }}"',
'          ng-click="area.selectBBOX()" ng-class="{active: area.draw}" type="button" translate>',
'          area.selectByBBOX',
'        </button>',
'      </div>',
'',
'      <div class="search-container" ng-init="search=\'\'" ng-if="!area.maponly">',
'        <button class="btn btn-link btn-sm search-clear" ng-click="search = \'\'" ng-show="search != \'\'">',
'          <i class="glyphicon glyphicon-remove-sign"></i>',
'        </button>',
'        <input class="search form-control input-sm" placeholder="{{ \'area.search\' | translate }}" ng-model="search">',
'      </div>',
'    </div>',
'  </div>',
'',
'  <div class="col-md-4" ng-if="!area.maponly">',
'',
'    <p class="alert alert-info">',
'      {{area.collection.getArray().length}} {{ \'area.area\' | translate }}',
'      <button ng-if="area.item.$resolved" class="btn btn-default btn-sm" ng-click="area.save()" translate>area.save</button>',
'      <input type="hidden" ng-if="!area.item.$resolved" ng-value="area.ids" name="orgCities">',
'    </p>',
'    ',
'    <ul class="list">',
'      <li dir-paginate="f in area.collection.getArray() | itemsPerPage: 20">',
'        <a class="text-danger pull-right" href="javascript:void(0)" ng-click="area.removeFromSelection(f)">',
'          <i class="glyphicon glyphicon-remove"></i>',
'        </a>',
'        {{f.get(\'_label\')}}',
'      </li>',
'    </ul>',
'    <dir-pagination-controls max-size="7"></dir-pagination-controls>',
'',
'    <div class="btn-group importexport" ng-if="area.canExport">',
'      <button class="btn btn-default btn-sm" ng-click="area.import()" translate>area.import</button>',
'      <button class="btn btn-default btn-sm" ng-click="area.export()" translate>area.export</button>',
'    </div>',
'',
'  </div>',
'',
'  <div class="loading" ng-show="area.loading">',
'    <i class="glyphicon glyphicon-map-marker glyphicon-spin"></i>',
'  </div>',
'',
'</div>',
'',''].join("\n"));
  }]);
})();